import React from "react";
import { INewInvoiceData } from "../../services/dashboard.services";
import NewMonthlySubscriptionItemLayout from "./NewMonthlySubscriptionItemLayout";

export default function NewMonthlySubscriptionData(props: IProps) {
  const { base_items } = props.invoiceData;
  return (
    <React.Fragment>
      {base_items &&
        base_items.map((subItem, index) => {
          return (
            <NewMonthlySubscriptionItemLayout
              key={subItem.id}
              id={subItem.id}
              amount={subItem.amount}
              quantity={subItem.quantity}
              productID={subItem.product_id}
              baseAmount={subItem.base_amount}
              productData={props.productData}
              country={props.country}
            ></NewMonthlySubscriptionItemLayout>
          );
        })}
    </React.Fragment>
  );
}

interface IProps {
  invoiceData: INewInvoiceData;
  productData: { [key: string]: string };
  country: string;
}
